/**
 * BundleCard — a card showing one bundle from the gallery.
 */

import { Link } from 'react-router-dom';
import type { RegistryBundle } from '../types/registry';
import './BundleCard.css';

interface BundleCardProps {
  bundle: RegistryBundle;
  showActions?: boolean;
}

export function BundleCard({ bundle, showActions = true }: BundleCardProps) {

  return (
    <article className="bundle-card">
      <header className="bundle-card__header">
        <h3 className="bundle-card__id">
          <Link to={`/bundles/${bundle.id}`}>{bundle.id}</Link>
        </h3>
        <span className={`bundle-card__tier bundle-card__tier--${bundle.tier}`}>
          {bundle.tier}
        </span>
      </header>

      <div className="bundle-card__meta">
        <span className="bundle-card__version">v{bundle.version}</span>
        <span className="bundle-card__count">
          {bundle.submodule_count} sub-modules
        </span>
      </div>

      {showActions && (
        <footer className="bundle-card__actions">
          <Link to={`/bundles/${bundle.id}`} className="bundle-card__btn">
            View
          </Link>
          <button
            type="button"
            className="bundle-card__btn bundle-card__btn--ghost"
            onClick={() => alert('Install bundle: API not yet available')}
          >
            Install
          </button>
        </footer>
      )}
    </article>
  );
}
